/**
 * ChatMessageAttachmentExtraData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileInfo } from './file_info'

/**
 * ChatMessageAttachmentExtraData
 */
export interface ChatMessageAttachmentExtraData {
  /** 文件 */
  file?: FileInfo
}

/**
 * ChatMessageAttachmentExtraData Schema
 */
export const ChatMessageAttachmentExtraDataSchema: SchemaDefinition = {
  properties: {
    file: {
      $ref: 'FileInfo',
      description: '文件',
      label: '文件',
    },
  },
  type: 'object',
}
